import { Property } from './interfaces';

export const idMIPRES: Property = {
    title: "ID MIPRES",
    type: "string"
}
